import { memo, useCallback } from "react";

import { routes } from "@/common/utils/routes";
import { SeeMoreBlock } from "components/blocks/SeeMoreBlock";
import { TagLink } from "components/widgets/TagList/TagLink";
import { FeedModuleTypeEnum, ITag } from "@/common/services/types";
import { useGetTrendingTags } from "@/common/hooks/useGetTrendingTags";
import { metricsBus } from "@/common/buses";
import { FeedModuleContainer } from "../FeedModules/FeedModuleContainer";

interface ITrendingTagsModuleProps {
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const TrendingTagsModule = memo(({ moduleId, moduleType }: ITrendingTagsModuleProps) => {
  const { trendingTags } = useGetTrendingTags();

  const handleTagClick = useCallback((tag: ITag) => () => {
    metricsBus.emit("tagClicked", { tag: tag.name, section: "Trending Tags" });
  }, []);

  if (!trendingTags.length) {
    return null;
  }

  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <SeeMoreBlock
        header="Trending Porn GIFs Tags"
        more={routes.trendingTags()}
        className="trendingTags canvas"
        list={true}
      >
        {trendingTags.map((tag: ITag) => (
          <TagLink
            key={tag.name}
            tag={tag}
            counts={true}
            onClick={handleTagClick(tag)}
          />
        ))}
      </SeeMoreBlock>
    </FeedModuleContainer>
  );
});
